import GenderBadge from './GenderBadge'

export default GenderBadge
